import { classed } from "@tw-classed/core";
import { withClassName } from "../../helpers";
import type { InputProps } from "./input.types";

const classedInputContainer = classed("group relative flex flex-col");

const classedLabel = classed(
  "group absolute left-4 top-1/2 -translate-y-7 font-extralight peer-focus:-translate-y-7 peer-placeholder-shown:-translate-y-1/2 transition-transform text-grey-500 peer-focus:scale-75 peer-placeholder-shown:scale-100 scale-75 origin-left",
);

const classedInput = classed(
  "flex group peer outline-none text-primary-900 hover:bg-primary-50 overflow-hidden border-2 rounded-lg border-grey-300 focus:border-primary-500 focus:border-2 transition placeholder-shown:border placeholder-shown:border-grey-500 disabled:bg-grey-100 disabled:border-grey-100 disabled:text-grey-300 disabled:pointer-events-none placeholder:opacity-0 focus:placeholder:opacity-100",
  {
    variants: {
      size: {
        normal: "px-4 pt-6 pb-2 h-14",
        large: "px-4 pt-6 pb-3 text-lg h-15",
      },
      state: {
        error: "border-error-600 placeholder-shown:border-error-600 bg-error-50",
        success: "border-success-600 placeholder-shown:border-success-600 bg-success-50",
      },
    },
  },
);

const classedIcon = classed("absolute right-4 top-1/2 -translate-y-1/2 text-2xl", {
  variants: {
    state: {
      error: "text-error-600",
      success: "text-success-700",
    },
    disabled: { true: "text-grey-300" },
  },
});

export const getInputContainerClass = withClassName(classedInputContainer);
export const getLabelClass = withClassName(classedLabel);
export const getInputClass = withClassName((props: Pick<InputProps, "state" | "size">) => classedInput(props));
export const getClassedIcon = withClassName((props: Pick<InputProps, "state" | "disabled">) => classedIcon(props));
